import type { SignedUpPatientInviteContext } from '../store/onboardingStore';
import { resolveCloudflareImagesUrlForWeb } from './resolveCloudflareImagesUrlForWeb';

export type OnboardingHeaderLogo =
  | { isPracticeBranding: true; src: string; alt: string }
  | { isPracticeBranding: false; alt: string };

/**
 * Resolves the logo shown in the onboarding header: the practice's own logo (an `<img>` from a
 * Cloudflare Images URL) when the practice has the branding package, otherwise the inline
 * Physiofit wordmark (rendered by the caller via `GenericSvg`, since only the SVGR component
 * transform can recolor it — a plain `<img>` src would render the mark's literal white fill).
 *
 * `practiceLogoUrl` is present only when the cloud function resolved a branded practice. Absent for
 * every unbranded practice, and for any client talking to a cloud function that predates ERS-61.
 */
export function resolveOnboardingHeaderLogo(
  inviteContext: SignedUpPatientInviteContext | undefined,
): OnboardingHeaderLogo {
  const practiceLogoUrl = inviteContext?.practiceLogoUrl?.trim();
  if (practiceLogoUrl) {
    return {
      isPracticeBranding: true,
      src: resolveCloudflareImagesUrlForWeb(practiceLogoUrl, 260),
      alt: inviteContext?.practiceName ?? '',
    };
  }
  return { isPracticeBranding: false, alt: 'Physiofit' };
}
